import { render } from "./ItemGroupList.vue?vue&type=template&id=36b58eda"
import script from "./ItemGroupList.vue?vue&type=script&lang=js"
export * from "./ItemGroupList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__